// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Shopify$Showside from "../utils/Shopify.bs.js";
import * as Caml_js_exceptions from "../../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";
import * as FetchUtils$Showside from "../utils/FetchUtils.bs.js";
import * as CustomScript$Showside from "../utils/CustomScript.bs.js";
import * as StoreCartTypes$Showside from "../utils/StoreCartTypes.bs.js";
import * as RollbarInstance$Showside from "../utils/RollbarInstance.bs.js";
import * as CartContextProvider$Showside from "../context/CartContextProvider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ExternalIntegrationProvider$Showside from "../context/ExternalIntegrationProvider.bs.js";
function useCustomAddToCart(param) {
  var match = ConfigurationProvider$Showside.use(undefined).config;
  return Belt_Option.map(Belt_Option.flatMap(Belt_Array.getBy(Belt_Option.mapWithDefault(match.transitiveAccount, [], function (account) {
    return account.customActions;
  }), function (script) {
    return script.addToCart;
  }), function (script) {
    return script.onClickFn;
  }), function (prim) {
    return prim.trim();
  });
}
function useAddToCart(configId, smartnavApiHost) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var settings = match.config.settings;
  var match$1 = CartContextProvider$Showside.useCart(undefined);
  var onUpdateCart = match$1.onUpdateCart;
  var mutateCart = match$1.mutateCart;
  var match$2 = ExternalIntegrationProvider$Showside.use(undefined);
  var onAddToCart = match$2.onAddToCart;
  var customAddToCart = useCustomAddToCart(undefined);
  return React.useCallback(function (product) {
    return function (variant, category, quantity) {
      var legacyProduct = Product$Showside.toLegacyDTO(product, variant);
      var variantId = CustomScript$Showside.getVariantId(legacyProduct);
      var legacyProduct$1 = CustomScript$Showside.prepareProduct(legacyProduct);
      var expectedCount = {
        contents: 0
      };
      Curry._2(mutateCart, function (cart) {
        try {
          var itemCount = cart.itemCount + quantity | 0;
          expectedCount.contents = itemCount;
          return {
            itemCount: itemCount,
            items: cart.items,
            currency: cart.currency
          };
        } catch (raw_e) {
          var e = Caml_js_exceptions.internalToOCamlException(raw_e);
          RollbarInstance$Showside.error2(e, "Failed to increment cart item count");
          return {
            itemCount: quantity,
            items: StoreCartTypes$Showside.empty.items,
            currency: StoreCartTypes$Showside.empty.currency
          };
        }
      }, false);
      var verifyAddToCart = async function (param) {
        var updatedCart = await Curry._2(mutateCart, function (a) {
          return a;
        }, false);
        if (updatedCart !== undefined && updatedCart.itemCount !== expectedCount.contents) {
          return await RollbarInstance$Showside.info2("Add to cart probably failed, the updated cart doesn't match what we expected", {
            updatedCart: JSON.stringify(updatedCart),
            expectedCount: JSON.stringify(expectedCount.contents),
            product: JSON.stringify(product),
            variant: JSON.stringify(variant),
            category: JSON.stringify(category),
            quantity: JSON.stringify(quantity)
          });
        }
      };
      setTimeout(function (param) {
        verifyAddToCart(undefined);
      }, 3000);
      var match = settings.cart;
      var match$1 = Shopify$Showside.isShopify(undefined);
      if (match) {
        return Curry._4(onUpdateCart, category, product, variant, quantity);
      }
      var exit = 0;
      if (customAddToCart !== undefined) {
        if (variantId !== undefined) {
          if (customAddToCart !== "") {
            return CustomScript$Showside.triggerCustomFunction(customAddToCart, product, variant, quantity, "add to cart", undefined, undefined);
          }
          exit = 2;
        }
      } else {
        exit = 2;
      }
      if (exit === 2 && match$1 && variantId !== undefined) {
        return FetchUtils$Showside.$$fetch(/* Post */2, Caml_option.some("{ \"quantity\": " + String(quantity) + ", \"id\": \"" + variantId + "\" }"), [["Accept", "application/json"], ["Content-Type", "application/json"]], undefined, undefined, FetchUtils$Showside.Decoding.ignoreDecode, "/cart/add.js").then(function (param) {
          return Promise.resolve(undefined);
        });
      }
      if (onAddToCart !== undefined) {
        return Promise.resolve(Curry._1(onAddToCart, legacyProduct$1));
      } else {
        return Promise.resolve(undefined);
      }
    };
  }, [customAddToCart, settings.cart]);
}
export { useCustomAddToCart, useAddToCart };
/* react Not a pure module */